// import APIs
import { getQualificationsByCostCenters } from 'RestAPIs/roster/qualifications';

// import external libraries
import { useQuery } from 'react-query';

export type GetQualificationsByCostCentersProps = {
  costCenters: string;
  startDate: string;
  endDate: string;
};

const useGetQualificationsByCostCenters = (
  { costCenters, startDate, endDate }: GetQualificationsByCostCentersProps,
  options: Record<string, any> = {}
) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['rosterPlanQualifications', costCenters, startDate, endDate],
    async () => {
      const { data } = await getQualificationsByCostCenters({
        costCenters,
        startDate,
        endDate
      });
      return data;
    },
    options
  );
  return { data, isFetching, isError, refetch };
};

export default useGetQualificationsByCostCenters;
